import { Deserializable } from '../_common/deserializable';

export class SpiderAccount implements Deserializable{
    id: number;
    source: number;
    sourceView: string;
    name: string;
    label: string;
    partnerId: string;
    apiKey: string;
    createdAt: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }

}
